module.exports = __webpack_public_path__ + "static/media/Communication_PictoCdlT.695320bb.png";